import React from 'react';
import MultiSelect from './MultiSelect';
import './FilterPanel.css';

export default function ConferenceFilterPanel({
  options = { Country: [], Price: [], type: [], year: [], topic: [] },
  activeFilters = {},
  onFilterChange,
  onResetAllFilters,
  resultsCount = 0,
  onSaveCurrentFilters,
  savingCurrentFilter = false
}) {
  const fallbacks = {
    Country: [],
    Price: [],
    type: [],
    year: [],
    topic: []
  };

  let safeOptions;
  if (!options || typeof options !== 'object' || Array.isArray(options) || options instanceof HTMLElement) {
    safeOptions = fallbacks;
  } else {
    safeOptions = {
      Country: Array.isArray(options.Country) ? options.Country : [],
      Price: Array.isArray(options.Price) ? options.Price : [],
      type: Array.isArray(options.type) ? options.type : [],
      year: Array.isArray(options.year) ? options.year : [],
      topic: Array.isArray(options.topic) ? options.topic : []
    };
  }

  const handleChange = (key, value) => {
    if (typeof onFilterChange === 'function') {
      onFilterChange(key, value);
    }
  };

  return (
    <div className="filter-panel-container">
      <div className="filter-panel-grid">
        <MultiSelect
          label="Country"
          options={safeOptions.Country.map(String)}
          selectedValues={activeFilters.Country || []}
          onChange={vals => handleChange('Country', vals)}
          placeholder="Filter by country..."
          className="filter-item"
        />
        <MultiSelect
          label="Price"
          options={safeOptions.Price.map(String)}
          selectedValues={activeFilters.Price || []}
          onChange={vals => handleChange('Price', vals)}
          placeholder="Filter by price..."
          className="filter-item"
        />
        <MultiSelect
          label="Type"
          options={safeOptions.type.map(String)}
          selectedValues={activeFilters.type || []}
          onChange={vals => handleChange('type', vals)}
          placeholder="Filter by type..."
          className="filter-item"
        />
        <MultiSelect
          label="Year"
          options={safeOptions.year.map(String)}
          selectedValues={activeFilters.year || []}
          onChange={vals => handleChange('year', vals)}
          placeholder="Filter by year..."
          className="filter-item"
        />
        <MultiSelect
          label="Topic"
          options={safeOptions.topic.map(String)}
          selectedValues={activeFilters.topic || []}
          onChange={vals => handleChange('topic', vals)}
          placeholder="Filter by topic..."
          className="filter-item"
        />
      </div>

      <div className="filter-panel-actions">
        <div className="filter-panel-info">
          <span className="results-summary">{resultsCount} results</span>
        </div>
        <div className="filter-panel-buttons">
          {typeof onResetAllFilters === 'function' && (
            <button
              type="button"
              className="filter-action-btn filter-reset-btn"
              onClick={onResetAllFilters}
            >
              <span className="filter-btn-icon" aria-hidden="true">↺</span>
              Reset filters
            </button>
          )}
          {typeof onSaveCurrentFilters === 'function' && (
            <button
              type="button"
              className="filter-action-btn filter-save-btn"
              onClick={onSaveCurrentFilters}
              disabled={savingCurrentFilter}
            >
              <span className="filter-btn-icon" aria-hidden="true">
                {savingCurrentFilter ? '⏳' : '💾'}
              </span>
              {savingCurrentFilter ? 'Saving...' : 'Save this filter'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
